import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { Img } from '@savgroup-front-common/core/atoms/Img';
import { SellerLogo } from '@savgroup-front-common/core/atoms/Logo/SellerLogo/SellerLogo';
import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';

import { InitContext } from '@/view/app/NewLayout/InitProvider/InitProvider.context';

import { AuthConfiguration } from '../../../../../../../../../configuration';
import {
  HandlingValues,
  PickupPointOption,
} from '../../../../../../IrshPages.types';
import messages from '../messages';

import { ChoosePickupPointCard } from './ChoosePickupPointCard/ChoosePickupPointCard';
import { getUrlLogoCarrier } from './PickupPointList.helpers';
import { $Container } from './PickupPointList.styles';

interface PickupPointListProps {
  onSelectPickupPoint: (pickupPointId: PickupPointOption) => void;
  pickupPoints: PickupPointOption[];
  handlingValues: HandlingValues;
  isImmediateDropAtStoreMethod: boolean;
}

const PickupPointList: React.FC<
  React.PropsWithChildren<PickupPointListProps>
> = ({
  children,
  onSelectPickupPoint,
  pickupPoints,
  handlingValues,
  isImmediateDropAtStoreMethod,
}) => {
  const intl = useIntl();

  const { orders } = useContext(InitContext);

  const sellerId = orders?.at(0)?.sellerId;

  return (
    <$Container>
      {children}
      {pickupPoints.map((pickupPointOption) => {
        const pickupPoint = pickupPointOption.data.pickupPoint;

        const normalizedDistance =
          pickupPoint.distanceInMeters < 1000
            ? pickupPoint.distanceInMeters
            : Math.round(pickupPoint.distanceInMeters / 100) / 10;
        const distanceUnit = pickupPoint.distanceInMeters < 1000 ? 'm' : 'km';

        const { longitude, latitude } = pickupPoint;
        const hasCoordinates = longitude || latitude;

        return (
          <ChoosePickupPointCard
            key={pickupPoint.id}
            value={pickupPoint.id}
            title={pickupPoint.name}
            onSelectPickupPoint={() => onSelectPickupPoint(pickupPointOption)}
            description={`${pickupPoint.adress}\n${pickupPoint.postalCode} ${pickupPoint.city}`}
            distance={
              hasCoordinates
                ? `${safeFormattedIntlString(
                    messages.distance,
                  )} ${intl.formatNumber(normalizedDistance)}${distanceUnit}`
                : undefined
            }
            price={pickupPointOption.data.transportPlan?.priceWithTax}
            logo={
              isImmediateDropAtStoreMethod ? (
                <SellerLogo
                  sellerId={sellerId ?? ''}
                  clientId={AuthConfiguration.clientId}
                />
              ) : (
                <Img
                  alt={pickupPoint.carrierName}
                  urls={getUrlLogoCarrier({
                    sellerId,
                    transportPlan: pickupPointOption.data.transportPlan,
                  })}
                />
              )
            }
            pickupPointOption={pickupPointOption}
            isSelected={
              pickupPoint.id === handlingValues.selectedPickupPoint?.value
            }
            transportPlan={pickupPointOption.data.transportPlan}
          />
        );
      })}
    </$Container>
  );
};

export default PickupPointList;
